module.exports = __webpack_public_path__ + "static/img/2.436826d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/UltralowTemperature/R23/2.jpg
// module id = rQaf
// module chunks = 1